var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFC727",
    d: "m10.298 2.633 1.32 2.64c.18.367.66.72 1.065.787l2.392.398c1.53.255 1.89 1.365.788 2.46l-1.86 1.86c-.315.315-.488.922-.39 1.358l.532 2.302c.42 1.822-.547 2.527-2.16 1.575l-2.242-1.328c-.405-.24-1.073-.24-1.485 0l-2.243 1.328c-1.605.952-2.58.24-2.16-1.575l.533-2.302c.097-.435-.075-1.043-.39-1.358l-1.86-1.86c-1.095-1.095-.743-2.205.787-2.46l2.393-.398c.397-.067.877-.42 1.057-.787l1.32-2.64c.72-1.433 1.89-1.433 2.603 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.d648a283146f2ba30562bf3e49f509a4.svg";
export { ForwardRef as ReactComponent };